import { render, staticRenderFns } from "./AppLoading.vue?vue&type=template&id=319936e2&scoped=true&"
import script from "./AppLoading.vue?vue&type=script&lang=js&"
export * from "./AppLoading.vue?vue&type=script&lang=js&"
import style0 from "./AppLoading.vue?vue&type=style&index=0&id=319936e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319936e2",
  null
  
)

export default component.exports